const TableFirmSettings = ({ children }) => {
  return (
    <div className="tab-content">
      <table
        className={
          "table table-borderless table-striped table-treatment has-specialty-icon has-height-25 block-table me-0"
        }
        id="treatment-summary-table"
      >
        {children}
      </table>
    </div>
  );
};

export default TableFirmSettings;
